import * as Sentry from '@sentry/react';
import axios, { AxiosError } from 'axios';

const SENTRY_DSN = 'https://e5b6d2483c7e4c6081d1d8405af301ed@sentry.io/1246470';

export function initSentry() {
    Sentry.init({
        dsn: SENTRY_DSN,
        enabled: true,
        environment: window.location.hostname,
        initialScope: {
            tags: { app: 'if-client-portal' }
        },
        // Marketing scripts injected through GTM (Mindbox, Kameleoon) throw their own errors that are not actionable here
        denyUrls: [/\/scripts\/v1\/tracker\.js/i, /mindbox/i, /googletagmanager\.com/i, /kameleoon\.(eu|com)/i],
        beforeSend(event, hint) {
            // Axios errors are only reported through captureApiError, which filters out 4xx and cancellations
            const original = hint?.originalException;
            if ((axios.isAxiosError(original) || axios.isCancel(original)) && !event.tags?.api_view) {
                return null;
            }
            return event;
        }
    });
}

export function captureApiError(error: AxiosError, viewId: string) {
    if (error.code === AxiosError.ERR_CANCELED) {
        return;
    }
    const status = error.response?.status;
    if (status !== undefined && status < 500) {
        return;
    }
    const path = (error.config?.url || '').split('?')[0];
    const reason = status !== undefined ? String(status) : error.code || 'network';
    Sentry.captureException(error, {
        tags: {
            api_view: viewId,
            api_method: (error.config?.method || '').toUpperCase(),
            api_path: path,
            api_error: reason
        },
        extra: {
            url: error.config?.url,
            base_url: error.config?.baseURL,
            timeout_ms: error.config?.timeout
        },
        fingerprint: ['api-error', viewId, path, reason]
    });
}

export function setSentryUser(user: { _id: string; emails?: string[] } | null) {
    Sentry.setUser(user ? { id: user._id, email: user.emails?.[0] } : null);
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
